export default __webpack_public_path__ + "static/media/authereum-logo.035176ec.svg";